import styled from "styled-components";
export const Wrapper = styled.div `
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  width: 132px;
`;
